@if (showNavBar()) {
  <div class="container">
    <div class="row">
      <div class="col">
        <nav class="navbar navbar-expand-lg navbar-light nav-border-bottom-spaced portal-nav-bar">
          @if (!isOverview()) {
            <div style="min-height: 43px">
              <a href="javascript:void(0)" class="btn nav-back-button" (click)="onBackClicked()"
                ><i class="fas fa-chevron-left"></i
              ></a>
              <a href="javascript:void(0)" class="navbar-brand" (click)="onBackClicked()">
                {{ backLabel() }}
              </a>
            </div>
          }

          @if (showRightMenu()) {
            <button
              (click)="toggleNavbar()"
              class="navbar-toggler rounded-0"
              [class.toggled]="navbarOpen"
              type="button">
              <span class="navbar-toggler-icon"></span>
            </button>
          }

          <div [ngClass]="{ show: navbarOpen }" class="collapse navbar-collapse show justify-content-end">
            <ul class="navbar-nav ml-auto">
              @if (showRightMenu()) {
                <li class="nav-item">
                  <a [href]="sanitizedNotificationUrl()" class="nav-link">{{
                    "GAST-PORTAL-NG.NAV-BAR.MESSAGES" | translate
                  }}</a>
                </li>

                <li class="nav-item">
                  <a [href]="sanitizedMyDataUrl()" class="nav-link">{{
                    "GAST-PORTAL-NG.NAV-BAR.MY-DATA" | translate
                  }}</a>
                </li>
              }

              @if (showProductsDropdown()) {
                <li class="nav-item">
                  <select
                    [ngModel]="selectedProduct()"
                    (change)="onProductSelected($any($event).target.value)"
                    class="form-control float-end rounded-0"
                    style="width: min-content">
                    @for (product of products(); track product) {
                      <option [value]="product">
                        {{ "GAST-PORTAL-NG.NAV-BAR.PRODUCT." + product | translate }}
                      </option>
                    }
                  </select>
                </li>
              }
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
}
